import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
 setAppSelectedVehicle,
 updateLocalVehicleDetails,
 updateVehiclesDetails,
} from "redux/actions/motorActions";
import FeatureCard from "../featureCard";
import StyleWrapper from "./style";

const Features = (props) => {
 const { selectedProposal, proposalToShow, planChanged = false, setPlanChanged = () => {} } = props;
 const dispatch = useDispatch();

 const { vehicles } = useSelector((state) => state.motor);

 const proposal = proposalToShow?.find((item) => item.productSubCode === selectedProposal);

 const onSelectNewFeatures = (data) => {
  // const vehicleToEdit = vehicles.find( v=> v.chassisNumber === props.vehicle);
  // if (vehicleToEdit?.selectedFeatures?.length) {
  //   vehicleToEdit.selectedFeatures = vehicleToEdit.selectedFeatures.filter(f => f.featureGroupName !== data.featureGroupName)
  //   vehicleToEdit.selectedFeatures.push(data)
  // } else {
  //   vehicleToEdit.selectedFeatures = [data]
  // }

  // props.updateVehicle(vehicleToEdit)
  // dispatch(updateLocalVehicleDetails());
  // props.setSelectedCar('');
  // props.setSelectedCar(props.vehicle);
  // dispatch(setAppSelectedVehicle(props.vehicle));

  vehicles.forEach((v) => {
   if (v.chassisNumber === props.vehicle) {
    if (v?.selectedFeatures?.length) {
     v.selectedFeatures = v.selectedFeatures.filter(
      (f) => f?.featureGroupName !== data?.featureGroupName
     );
     v.selectedFeatures.push(data);
    } else {
     v.selectedFeatures = [data];
    }
   }
  });
  console.log(vehicles,"ppp");

  dispatch(updateVehiclesDetails([...vehicles]));
 };
 return (
  <StyleWrapper>
   {selectedProposal !== "Mecha_MI" &&
    proposal?.vehicleArray[0]?.applicableFeatureGroup?.map((feature, i) => (
     <FeatureCard
      onSelectFeatures={onSelectNewFeatures}
      planChanged={planChanged}
      setPlanChanged={setPlanChanged}
      key={"feature_" + i}
      {...feature}    
      selectedProposal={selectedProposal}
      businessColor={props.businessColor}
      businessLine={props.businessLine}
     />
    ))}
  </StyleWrapper>
 );
};

export default Features;
